import { stripHtmlToPlainText } from '../../../shared/html-text.js';
import { columnLeftLabels } from '../column-left.config.js';

/** OpenCart-taalstrings gebruiken vaak &euml; i.p.v. UTF-8; Vue {{ }} decodeert die niet. */
export function decodeLegacyOcText(value, fallback = '') {
  if (!value || typeof value !== 'string') {
    return fallback;
  }
  const decoded = stripHtmlToPlainText(value);
  return decoded || fallback;
}

export function normalizeColumnLeftBoot(boot) {
  const b = boot && typeof boot === 'object' ? boot : {};
  return {
    title: decodeLegacyOcText(b.title, columnLeftLabels.title),
    categories: Array.isArray(b.categories) ? b.categories : [],
    activeCategoryId: Number(b.activeCategoryId) || 0,
    activeChildId: Number(b.activeChildId) || 0,
    activeChildId2: Number(b.activeChildId2) || 0
  };
}

export function isCategoryActive(node, active) {
  const id = Number(node.categoryId);
  if (!id) return false;
  return (
    id === active.activeCategoryId ||
    id === active.activeChildId ||
    id === active.activeChildId2
  );
}

export function isExactActive(node, active) {
  const id = Number(node.categoryId);
  if (!id) return false;
  if (active.activeChildId2) return id === active.activeChildId2;
  if (active.activeChildId) return id === active.activeChildId;
  return id === active.activeCategoryId;
}
